<template>
    <div class="columns is-multiline">
        <app-top-brand v-for="brand in fetchBrands" v-bind:brand="brand" :key="brand.id"></app-top-brand>
    </div>
</template>

<script>
    import TopBrand from './TopBrand'
    export default {
        props: ['brandCategory'],
        components: {
            appTopBrand: TopBrand
        },
        computed: {
            fetchBrands() {
                if (this.brandCategory === 'Japan') {
                    return this.$store.getters.topJapaneseBrands
                } else {
                    return this.$store.getters.topOtherBrands
                }
            }
        }
    }
</script>

<style scoped>
    .columns {
        margin-top: 20px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Brand/TopBrandContainer.vue